import { FormikErrors, FormikTouched } from 'formik';

type Errors = FormikErrors<any>;
type Touched = FormikTouched<any>;

export function clearBlockErrorsIfEmpty(
  errors: Errors,
  setErrors: (errors: Errors) => void,
  blockPath: string,
) {
  const newErrors = { ...errors };
  const blockErrors = (newErrors as any)[blockPath];
  // если блок существует и это объект
  if (blockErrors && typeof blockErrors === 'object') {
    const hasKeys = Object.keys(blockErrors).length > 0;
    if (!hasKeys) {
      // удаляем пустой объект
      delete (newErrors as any)[blockPath];
      setErrors(newErrors);
    }
    //  console.log("отработал clearBlockErrorsIfEmpty")
  }
}

export function clearConditionalErrors(
  errors: Errors,
  touched: Touched,
  setErrors: (e: Errors) => void,
  setTouched: (t: Touched) => void,
  flags: { isPriceDynamic?: boolean; has_kidsPrice?: boolean },
) {
  let newErrors = { ...errors };
  let newTouched = { ...touched };
  if (flags.isPriceDynamic === false) {
    delete (newErrors as any).add_price;
    delete (newTouched as any).add_price;
  }
  if (flags.has_kidsPrice === false) {
    delete (newErrors as any).kidsPrice;
    delete (newTouched as any).kidsPrice;
  }
  setErrors(newErrors);
  setTouched(newTouched);
  // console.log("отработал clearConditionalErrors")
}
